export const fontSans = 'var(--app-font-sans)'

export const settingsSubheaderSx = {
  position: 'static',
  bgcolor: 'transparent',
  py: 0.375,
  px: 1.25,
  mt: '12px',
  mb: '8px',
  lineHeight: '13px',
  fontSize: 11,
  fontWeight: 600,
  letterSpacing: 0,
  color: 'var(--app-text-secondary)',
  fontFamily: fontSans,
}

export const settingsItemButtonSx = {
  py: 0,
  pl: '2px',
  pr: '12px',
  mb: '1px',
  minHeight: 32,
  height: 32,
  borderRadius: 'var(--app-radius-md)',
  border: 'none',
  fontFamily: fontSans,
  transition: 'background 0.2s ease',
  '&:hover': {
    bgcolor: 'var(--app-secondary-nav-hover-thread, #f4f4f5)',
    borderColor: 'transparent',
  },
  '&.Mui-selected': {
    bgcolor: 'var(--app-secondary-nav-selected-thread, #f4f4f5)',
    borderColor: 'transparent',
    '&:hover': {
      bgcolor: 'var(--app-secondary-nav-selected-thread, #f4f4f5)',
    },
    '& .MuiListItemText-primary': {
      fontWeight: 500,
      color: 'var(--app-text-primary)',
    },
    '& .MuiListItemIcon-root': {
      color: 'var(--app-text-primary)',
    },
  },
  '&.Mui-focusVisible': { outline: '2px solid', outlineColor: 'var(--app-primary, #0078d4)', outlineOffset: 1 },
}

export const settingsItemIconSx = { minWidth: 28, mr: 0.75, justifyContent: 'center', color: 'var(--app-text-secondary)' }
